/** Один запрос за раз — по-настоящему.
 *
 * Флаг в состоянии React для этого не годится: он виден обработчику только
 * после коммита, поэтому очередь нажатий внутри одного тика проскакивает
 * целиком. Замерено: три тапа по «Внести» — три взноса, 21 $ вместо 7. Ни
 * `disabled`, ни `aria-disabled` тут не помогают: React ставит атрибут в тот же
 * момент, что и обновляет состояние.
 *
 * Нужно только там, где повтор СОЗДАЁТ что-то новое: взнос, запись траты,
 * снимок, оплата подписки. Правки (PATCH/PUT/DELETE) идемпотентны — второй тот
 * же запрос ничего не портит, и лишний сторож там был бы шумом.
 */
import { useRef } from "react";

export function useOnce(): (call: () => Promise<unknown>) => void {
  const inFlight = useRef(false);
  return (call) => {
    if (inFlight.current) return;
    inFlight.current = true;
    void call().finally(() => {
      inFlight.current = false;
    });
  };
}
